import { useState } from "react";
import BaseModal from "../baseModal";

const appOrigin = window.location.origin;
const TermsOfService = ({ show, close, action }) => {
    const [termsBtn, setTermsBtn] = useState(false);

    function check(e) {
        const { checked } = e.target;
        setTermsBtn(checked);
    }

    return (
        <BaseModal show={show} handleClose={close}>
            <div className="terms-of-service">
                <h2>Terms of Service</h2>
                <p id="subtitle">IN ACCESSING AND/OR USING DERUPT, YOU ACKNOWLEDGE AND AGREE THAT:</p>

                <ol>
                    <li> DERUPT IS/ARE PROVIDED ON AN “AS-IS” AND “AS AVAILABLE” BASIS, AND DERUPT (“OPERATOR”) AND ITS AFFILIATES (SAVE TO THE EXTENT PROHIBITED BY APPLICABLE LAWS) EXPRESSLY DISCLAIM ANY AND ALL REPRESENTATIONS, WARRANTIES AND/OR CONDITIONS OF ANY KIND IN RESPECT THEREOF, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING ALL WARRANTIES OR CONDITIONS OF MERCHANTABILITY, MERCHANTABLE QUALITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, QUIET ENJOYMENT, ACCURACY, OR NON-INFRINGEMENT.</li>
                    <li> OPERATOR AND ITS AFFILIATES HAS NOT MADE AND MAKES NO REPRESENTATION, WARRANTY AND/OR CONDITION OF ANY KIND THAT DERUPT WILL MEET YOUR REQUIREMENTS, OR WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE BASIS, OR WILL BE ACCURATE, RELIABLE, FREE OF VIRUSES OR OTHER HARMFUL CODE, COMPLETE, LEGAL, OR SAFE.</li>
                    <li> YOU SHALL HAVE NO CLAIM AGAINST OPERATOR AND/OR ITS AFFILIATES IN RESPECT OF ANY LOSS SUFFERED BY YOU IN RELATION TO OR ARISING FROM YOUR ACCESS AND/OR USE OF DERUPT.</li>
                    <li> ANY CONTENT, INCLUDING BUT NOT LIMITED TO TEXT, IMAGES, VIDEOS, OR ANY OTHER MATERIALS, THAT YOU UPLOAD, ATTACH, POST, CHIME, REPLY, OR OTHERWISE MAKE AVAILABLE ON DERUPT ("USER-GENERATED CONTENT") SHALL REMAIN YOUR SOLE PROPERTY, AND YOU REPRESENT AND WARRANT THAT YOU HAVE THE LEGAL RIGHT TO USE SUCH USER-GENERATED CONTENT AND TO GRANT OPERATOR THE LICENSE TO USE SUCH CONTENT AS DESCRIBED IN THESE TERMS OF SERVICE.</li>
                </ol>

                <label id="accepted-terms-checkbox" htmlFor="accept-terms-checkbox">
                    <input type="checkbox" id="accept-terms-checkbox" value={termsBtn} onChange={check} />
                    <small style={{ color: "#000" }}> I agree to the Terms of Service</small>
                </label>
                <button className="btn" disabled={!termsBtn} onClick={action}>Accept</button>
            </div>

        </BaseModal >
    );
}

export default TermsOfService;